<template>
  <div>
    <div v-if="isAgent() || isAdmin()">
      <seller-select-modal class="component-margin" @selected="selectedSeller($event)"/>
      <b-tabs>
        <b-tab v-on:click="doActiveDay" class="tab-margin" title="売上分析(日)">
          <daily-analysis :editable="true" :imember="memberId" :version="versionD" @updateVersion="updateVersion($event)"/>
        </b-tab>
        <b-tab v-on:click="doActiveWeek" class="tab-margin" title="売上分析(週)">
          <weekly-analysis :editable="true" :imember="memberId" :version="versionW"/>
        </b-tab>
        <b-tab v-on:click="doActiveMonth" class="tab-margin" title="売上分析(月)">
          <monthly-analysis :editable="true" :imember="memberId" :version="versionM"/>
        </b-tab>
        <b-tab v-on:click="doActiveAll" class="tab-margin" title="売上分析(累積)">
          <total-analysis :editable="true" :imember="memberId" :version="versionA"/>
        </b-tab>
        <b-tab class="tab-margin" title="送料分析">
          <shipment-fee-analysis :editable="true" :imember="memberId"/>
        </b-tab>
      </b-tabs>
    </div>
    <div v-if="isSeller()">
      <b-tabs>
        <b-tab v-on:click="doActiveDay" class="tab-margin" title="売上分析(日)">
          <daily-analysis :editable="false" :version="versionD"/>
        </b-tab>
        <b-tab v-on:click="doActiveWeek" class="tab-margin" title="売上分析(週)">
          <weekly-analysis :editable="false" :version="versionW"/>
        </b-tab>
        <b-tab v-on:click="doActiveMonth" class="tab-margin" title="売上分析(月)">
          <monthly-analysis :editable="false" :version="versionM"/>
        </b-tab>
        <b-tab v-on:click="doActiveAll" class="tab-margin" title="売上分析(累積)">
          <total-analysis :editable="false" :version="versionA"/>
        </b-tab>
        <b-tab class="tab-margin" title="送料分析">
          <shipment-fee-analysis :editable="false"/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import DailyAnalysis from '@/components/analysis/DailyAnalysis';
import WeeklyAnalysis from '@/components/analysis/WeeklyAnalysis';
import MonthlyAnalysis from '@/components/analysis/MonthlyAnalysis';
import TotalAnalysis from '@/components/analysis/TotalAnalysis';
import ShipmentFeeAnalysis from '@/components/analysis/ShipmentFeeAnalysis';
import SellerSelectModal from '@/components/common/SellerSelectModal';

export default {
  mixins: [BaseView],
  data() {
    return {
      memberId: '',
      versionD: 1,
      versionW: 0,
      versionM: 0,
      versionA: 0
    };
  },
  created() { this.updateTitle('分析'); },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
    },
    doActiveDay(){
      this.versionD = this.versionD + 1;
    },
    doActiveWeek(){
      this.versionW = this.versionW + 1;
    },
    doActiveMonth(){
      this.versionM = this.versionM + 1;
    },
    doActiveAll(){
      this.versionA = this.versionA + 1;
    },
    updateVersion($event) {
      // this.versionW = this.versionW + 1;
      // this.versionM = this.versionM + 1;
      // this.versionA = this.versionA + 1;
    },
  },
};

Vue.component('daily-analysis', DailyAnalysis);
Vue.component('weekly-analysis', WeeklyAnalysis);
Vue.component('monthly-analysis', MonthlyAnalysis);
Vue.component('total-analysis', TotalAnalysis);
Vue.component('shipment-fee-analysis', ShipmentFeeAnalysis);
Vue.component('seller-select-modal', SellerSelectModal);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
